import get from 'lodash/get'

// TODO: Move to fly-ql
export default function getSubjectToGovtApproval(itinerary) {
  // Returns true if any segment on itinerary has isSubjectToGovtApproval set to true,
  // and false otherwise
  let flag = false
  const slices = get(itinerary, 'slices', [])
  slices.some((slice) => {
    const segments = get(slice, 'segments', [])

    if (segments.find((segment) => segment.isSubjectToGovtApproval)) {
      flag = true
      return true
    }
    return false
  })
  return flag
}
